(function () {
  'use strict';

  var body = document.body;
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.querySelector('.cart-drawer-overlay');
  var lastTrigger = null;
  var busy = false;
  var recentKey = 'thw-recently-viewed';

  if (!drawer || !overlay) return;

  function focusable() {
    return Array.prototype.filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.closest('[hidden]');
    });
  }

  function openCart(trigger) {
    lastTrigger = trigger || document.activeElement;
    body.classList.add('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    overlay.setAttribute('aria-hidden', 'false');
    var close = drawer.querySelector('.cart-drawer__close');
    if (close) window.setTimeout(function () { close.focus(); }, 30);
  }

  function closeCart() {
    if (!body.classList.contains('cart-drawer-open')) return;
    body.classList.remove('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    overlay.setAttribute('aria-hidden', 'true');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function bindControls() {
    document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openCart(trigger);
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (trigger) {
      trigger.addEventListener('click', closeCart);
    });
    drawer.querySelectorAll('[data-cart-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        changeLine(button.dataset.line, button.dataset.quantity);
      });
    });
    drawer.querySelectorAll('[data-cart-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () { selectTab(tab.dataset.cartTab); });
    });
  }

  function getRecent() {
    try { return JSON.parse(window.localStorage.getItem(recentKey) || '[]'); } catch (error) { return []; }
  }

  function renderRecent() {
    var list = drawer.querySelector('[data-recent-list]');
    if (!list) return;
    var products = getRecent();
    if (!products.length) {
      list.innerHTML = '<p class="cart-drawer__recent-empty">Products you view will appear here.</p>';
      return;
    }
    list.innerHTML = products.map(function (product) {
      return '<a class="cart-drawer__recent-card" href="' + product.url + '">' +
        (product.image ? '<img src="' + product.image + '" alt="" width="92" height="92" loading="lazy">' : '') +
        '<span><strong>' + product.title + '</strong><span>' + product.price + '</span></span></a>';
    }).join('');
  }

  function selectTab(name) {
    drawer.querySelectorAll('[data-cart-tab]').forEach(function (tab) {
      var active = tab.dataset.cartTab === name;
      tab.classList.toggle('cart-drawer__tab--active', active);
      tab.classList.toggle('cart-drawer__tab--muted', !active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    drawer.querySelectorAll('[data-cart-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.cartPanel !== name;
    });
    if (name === 'recent') renderRecent();
  }

  function rememberCurrentProduct() {
    var source = document.getElementById('thw-current-product');
    if (!source) return;
    try {
      var product = JSON.parse(source.textContent);
      var item = { id: product.id, title: product.title, url: product.url, image: product.image, price: product.price || '' };
      var products = getRecent().filter(function (entry) { return entry.id !== item.id; });
      products.unshift(item);
      window.localStorage.setItem(recentKey, JSON.stringify(products.slice(0, 6)));
    } catch (error) { /* local storage is optional */ }
  }

  function replaceCartMarkup(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var nextDrawer = parsed.getElementById('cartDrawer');
    var nextOverlay = parsed.querySelector('.cart-drawer-overlay');
    if (!nextDrawer || !nextOverlay) return;
    drawer.replaceWith(nextDrawer);
    overlay.replaceWith(nextOverlay);
    drawer = nextDrawer;
    overlay = nextOverlay;
    bindControls();
    selectTab('cart');
  }

  function refreshCart(keepOpen) {
    return fetch(window.location.pathname + '?sections=header', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        if (sections.header) replaceCartMarkup(sections.header);
        document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
          var count = drawer.querySelector('[data-cart-count]');
          if (count) el.textContent = count.textContent;
        });
        if (keepOpen) openCart(lastTrigger);
      });
  }

  function changeLine(line, quantity) {
    if (busy) return;
    busy = true;
    drawer.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function () { return refreshCart(true); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { busy = false; if (drawer) drawer.classList.remove('is-loading'); });
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      busy = true;
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (response) { if (!response.ok) throw new Error('Unable to add item'); return response.json(); })
        .then(function () { return refreshCart(true); })
        .catch(function () { form.submit(); })
        .finally(function () { busy = false; });
    });
  });

  document.addEventListener('keydown', function (event) {
    if (!body.classList.contains('cart-drawer-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); closeCart(); return; }
    if (event.key !== 'Tab') return;
    var elements = focusable();
    if (!elements.length) return;
    if (event.shiftKey && document.activeElement === elements[0]) { event.preventDefault(); elements[elements.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === elements[elements.length - 1]) { event.preventDefault(); elements[0].focus(); }
  });

  bindControls();
  rememberCurrentProduct();
  renderRecent();
}());
